import { useState, useEffect } from 'react'

export const useDimensions = ({ elem }) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const event = 'resize'

    setDimensions({ width: elem?.getBoundingClientRect().width ?? 0, height: elem?.getBoundingClientRect().height ?? 0 })

    const handleResize = () => setDimensions({ width: elem?.getBoundingClientRect().width ?? 0, height: elem?.getBoundingClientRect().height ?? 0 })
    window.addEventListener(event, handleResize)

    return () => {
      window.removeEventListener(event, handleResize)
    }
  }, [elem])

  return dimensions
}
